export default "__VITE_ASSET__5fec2719__"